import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { doctor, medalicon } from "../../components/imagepath";
import FeatherIcon from "feather-icons-react";
import { Link, useParams } from "react-router-dom";
import { fetchUserById } from "../../services/userService";
import {sendPasswordResetEmail} from "../../services/authService";
import LoadingSpinner from "../../components/Common/LoadingSpinner"; // ✅ Imported here
import {BASE_URL_IMAGE} from "../../config/api";// Base URL for profile image
import { decrypt } from '../../utils/encryption';

const UserProfile = () => {
  const { id } = useParams();
  const [profileInfo, setProfileInfo] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ Loading state
  const [error, setError] = useState(null);
  const decryptedId = decrypt(id);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // ✅ Start loading
        const user = await fetchUserById(decryptedId);
        setProfileInfo(user);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false); // ✅ Stop loading
      }
    };

    fetchData();
  }, [decryptedId]);

  const handleResetPassword = async () => {
    try {
      setIsSendingReset(true);
      const response = await sendPasswordResetEmail(decryptedId);
      console.log(response);
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setIsSendingReset(false);
    }
  };

  if (error) return <div>Error: {error}</div>;

  if (loading) return <LoadingSpinner message="Fetching user profile..." />; // ✅ Show loader

  const aboutInfo = [
    { label: "Full Name", value: profileInfo.user_name },
    { label: "Mobile", value: profileInfo.user_contact },
    { label: "Email", value: profileInfo.user_email },
    { label: "Department", value: profileInfo.department_name },
  ];

  const specialities = [
    { title: "Designation", detail: profileInfo.user_designation },
    { title: "Qualification", detail: profileInfo.user_qualification },
    { title: "Teaching Experience", detail: profileInfo.user_teaching_experience },
    { title: "Industrial Experience", detail: profileInfo.user_industrial_experience },
    { title: "Specialization", detail: profileInfo.user_specialization },
    { title: "International Publications", detail: profileInfo.user_international_publication },
    { title: "Domestic Publications", detail: profileInfo.user_domestic_publication },
  ];

  const shortBio = profileInfo.user_biography || "No biography available.";

  const profileImageURL = profileInfo.user_profile_img
    ? `${BASE_URL_IMAGE}/uploads/userProfiles/${profileInfo.user_profile_img}`
    : "/default-profile.jpg";

  return (
    <div>
      <Helmet>
        <title>User Profile | CRM Jnec</title>
      </Helmet>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/list-users">Users</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <FeatherIcon icon="chevron-right" />
                  </li>
                  <li className="breadcrumb-item active">User Profile</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-2 text-center">
                      <img
                        src={profileImageURL}
                        alt="Profile"
                        className="img-fluid rounded"
                        style={{
                          maxHeight: "130px",
                          objectFit: "cover",
                          borderBottom: "5px solid #9d663f",
                        }}
                      />
                    </div>
                    <div className="col-md-7">
                      <h4 className="fw-bold mb-1 text-darkbrown">
                        {profileInfo.user_name}
                      </h4>
                      <div className="text-muted mb-1 text-darkbrown">
                        {profileInfo.user_email}
                      </div>
                      <div className="text-muted mb-1 text-darkbrown">
                        {profileInfo.user_contact}
                      </div>
                      <div className="text-muted text-darkbrown">
                        {profileInfo.department_name}
                      </div>
                    </div>
                    <div className="col-md-3 text-end d-flex">
                      <Link
                        to={`/edit-users/${encodeURIComponent(id)}`}
                        className="btn btn-secondaryi"
                      >
                        Update Profile
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* About Section */}
              <div className="row">
                <div className="col-lg-8">
                  <div className="doctor-personals-grp">
                    <div className="card">
                      <div className="card-body">
                        <div className="tab-content-set">
                          <ul className="nav">
                            <li>
                              <Link to="#" className="active ">
                                <span className="set-about-icon me-2">
                                  <img src={doctor} alt="" />
                                </span>
                                About
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="personal-list-out">
                          <div className="row">
                            {aboutInfo.map((item, i) => (
                              <div className="col-xl-3 col-md-6" key={i}>
                                <div className="detail-personal">
                                  <h2>{item.label}</h2>
                                  <h3 className="text-brown">{item.value}</h3>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="hello-park">
                          <span>Bio</span>
                          <p className="text-brown">{shortBio}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Speciality Section */}
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="doctor-personals-grp">
                        <div className="card">
                          <div className="card-body">
                            <div className="heading-detail mb-3">
                              <h4>Speciality</h4>
                            </div>
                            <div className="row">
                              {specialities.map((item, index) => (
                                <div className="col-md-3 mb-3" key={index}>
                                  <div className="personal-activity">
                                    <div className="personal-icons status-grey">
                                      <img src={medalicon} alt="" />
                                    </div>
                                    <div className="views-personal">
                                      <h4>{item.title}</h4>
                                      <h5 className="text-brown">{item.detail}</h5>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Social Media */}
                <div className="col-lg-4">
                  <div className="doctor-personals-grp">
                    <div className="card">
                      <div className="card-body">
                        <div className="heading-detail mb-3">
                          <h4>Social Media</h4>
                        </div>
                        <ul className="list-unstyled mt-3">
                          <li className="d-flex align-items-center mb-2">
                            <FeatherIcon icon="facebook" size={16} className="me-2" />
                            <h5 className="mb-0 me-2">Facebook Profile:</h5>
                            <a
                              href={
                                profileInfo.user_facebook_link?.startsWith("http")
                                  ? profileInfo.user_facebook_link
                                  : `https://${profileInfo.user_facebook_link}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View{" "}
                              <FeatherIcon icon="external-link" size={14} className="ms-1" />
                            </a>
                          </li>
                          <li className="d-flex align-items-center">
                            <FeatherIcon icon="linkedin" size={16} className="me-2" />
                            <h5 className="mb-0 me-2">LinkedIn Profile:</h5>
                            <a
                              href={
                                profileInfo.user_linkedin_link?.startsWith("http")
                                  ? profileInfo.user_linkedin_link
                                  : `https://${profileInfo.user_linkedin_link}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View{" "}
                              <FeatherIcon icon="external-link" size={14} className="ms-1" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> {/* End Right Col */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
